require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-your-web-design-career-will-flourish-if-you-learn-to-code.json") })
        }
      }, "path---blog-your-web-design-career-will-flourish-if-you-learn-to-code");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-your-web-design-career-will-flourish-if-you-learn-to-code!./.cache/json/blog-your-web-design-career-will-flourish-if-you-learn-to-code.json
// module id = 1149
// module chunks = 231608221292675